// S-2/S-3 wave 2 — pure helpers for the login-page lockout countdown. Extracted
// from LoginPage so the derivation + formatting are unit-testable without
// rendering the (provider-heavy) page. The component owns the React state; these
// stay side-effect-free.

/** Seconds left until `lockUntil` (0 when unset or already elapsed). */
export function lockRemainingSeconds(lockUntil: number | null, now: number): number {
  return lockUntil != null ? Math.max(0, Math.ceil((lockUntil - now) / 1000)) : 0;
}

/** True while a lock is active (a future lockUntil with time still remaining). */
export function isLockActive(lockUntil: number | null, now: number): boolean {
  return lockUntil != null && lockRemainingSeconds(lockUntil, now) > 0;
}

const FA_DIGITS = "۰۱۲۳۴۵۶۷۸۹";

/** Format a remaining-seconds value as Persian-digit mm:ss (e.g. ۰۴:۵۹). */
export function formatLockCountdown(secs: number): string {
  const safe = Math.max(0, Math.floor(secs));
  const mm = String(Math.floor(safe / 60)).padStart(2, "0");
  const ss = String(safe % 60).padStart(2, "0");
  return `${mm}:${ss}`.replace(/[0-9]/g, (d) => FA_DIGITS[Number(d)]);
}
